import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import "react-table/react-table.css";
import axios from "axios";
import ReactTable from "react-table";

import contractStatusFormatter from "helpers/contractStatusFormatter";
import FindContractById from "./FindContractById";
import { ContractCsvDownload } from "components/shared";

const ALL_VALUE = [0, 1, 2, 3, 6];

import {
  ContractLinkButton,
  TableFilterButtons,
  nextButton,
  prevButton,
} from "components/shared";

class EntityContractsTable extends React.Component {
  state = {
    tableData: [],
    loading: false,
    error: null,
    pages: null,
    activeFilter: 1,
  };

  table = React.createRef();

  onFilterButtonClick = (e, filter) => {
    e.preventDefault();
    const { activeFilter } = this.state;

    if (activeFilter !== filter) {
      this.setState({ activeFilter: filter });
      this.onFetchData(this.table.current.state, null, filter);
    }
  };

  onFetchData = (state, instance, activeFilter = this.state.activeFilter) => {
    const { dealerId, fetchUrl, salespersonId } = this.props;
    const { page, pageSize, sorted, filtered } = state;

    if (!fetchUrl) return;

    this.setState({ loading: true });

    filtered.forEach((filter) => {
      let filteredObject = "";

      switch (filter.id) {
        case "name":
          filteredObject = "dealer";
          break;
        case "cost":
          filteredObject = "self";
          break;
        case "first_name":
          filteredObject = "renter";
          break;
        case "last_name":
          filteredObject = "renter";
          break;
        case "home_phone":
          filteredObject = "renter";
          break;
        case "tax_state":
          filteredObject = "self";
          break;
        case "id":
          filteredObject = "self";
          break;
      }

      filter.object = filteredObject;
    });

    const req = {
      page: page * pageSize,
      page_size: pageSize,
      sorted,
      filtered,
      status: activeFilter,
    };

    if (dealerId) {
      req.dealer_id = dealerId;
    }

    if (salespersonId) {
      req.salesperson_id = salespersonId;
    }

    if (this.axiosCancelSource) {
      this.axiosCancelSource.cancel("Cancelled");
    }

    this.axiosCancelSource = axios.CancelToken.source();

    axios
      .post(fetchUrl, req, {
        cancelToken: this.axiosCancelSource.token,
      })
      .then((res) => {
        let numPages = 0;

        if (res.data.total < pageSize) {
          numPages = 1;
        } else {
          numPages = Math.ceil(res.data.total / pageSize);
        }

        this.setState({
          tableData: res.data.data,
          pages: numPages,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: {
            header: "There was a problem loading contracts",
            text: err.response.data.ui_message,
          },
        });
      });
  };

  render() {
    const { showDealer } = this.props;
    const { tableData, loading, activeFilter, error, pages } = this.state;

    let filterText = "";

    switch (activeFilter) {
      case 0:
        filterText = "Incomplete";
        break;
      case 1:
        filterText = "Submitted";
        break;
      case 2:
        filterText = "Approved";
        break;
      case 3:
        filterText = "Declined";
        break;
      case 6:
        filterText = "Completed";
        break;
      default:
        filterText = "All";
        break;
    }

    const filterButtons = [
      { text: "All", value: ALL_VALUE, color: "purple" },
      { text: "Submitted", value: 1, color: "blue" },
      { text: "Approved", value: 2, color: "green" },
      { text: "Completed", value: 6, color: "teal" },
      { text: "Incomplete", value: 0, color: "yellow" },
      { text: "Declined", value: 3, color: "red" },
    ];

    const filterObj = filterButtons.find((f) => f.value === activeFilter);

    return (
      <div>
        <Segment padded>
          <div style={{ marginBottom: "2em" }}>
            <FindContractById />
          </div>
          <div>
            <TableFilterButtons
              activeFilter={activeFilter}
              onFilterButtonClick={this.onFilterButtonClick}
              buttons={filterButtons}
              loading={loading}
            />
            <Divider hidden />
            <ReactTable
              data={tableData}
              ref={this.table}
              manual
              pages={pages}
              onFetchData={this.onFetchData}
              columns={[
                {
                  Header: "",
                  width: 50,
                  id: "actions",
                  sortable: false,
                  filterable: false,
                  accessor: (d) => (
                    <ContractLinkButton
                      id={d.id}
                      status={d.status}
                      // color={filterObj.color}
                    />
                  ),
                },
                {
                  Header: "#",
                  accessor: "id",
                  sortable: false,
                  filterable: false,
                  width: 80,
                },
                {
                  Header: "Dealer",
                  id: "name",
                  accessor: (d) => (d.dealer ? d.dealer.name : "n/a"),
                  show: showDealer,
                },
                {
                  Header: "Cost",
                  id: "cost",
                  filterable: false,
                  width: 100,
                  sortable: false,
                  accessor: (d) =>
                    d.final_cost_of_unit ? `$${d.final_cost_of_unit}` : "n/a",
                },
                {
                  Header: "Status",
                  id: "status",
                  width: 120,
                  filterable: false,
                  sortable: false,
                  accessor: (d) => {
                    return contractStatusFormatter(
                      d.queue_status ? "queue" : "",
                      d.queue_status ? d.queue_status : d.status
                    );
                  },
                },
                {
                  Header: "Last Updated",
                  id: "updated",
                  filterable: false,
                  sortable: false,
                  accessor: (d) =>
                    d.updated_at_formatted
                      ? d.updated_at_formatted
                      : d.submitted_at_formatted,
                },
                {
                  Header: "Customer First Name",
                  id: "first_name",
                  filterable: true,
                  sortable: false,
                  accessor: (d) =>
                    d.renter && d.renter.first_name
                      ? `${d.renter.first_name}`
                      : "n/a",
                },
                {
                  Header: "Customer Last Name",
                  id: "last_name",
                  filterable: true,
                  sortable: false,
                  accessor: (d) =>
                    d.renter && d.renter.last_name
                      ? `${d.renter.last_name}`
                      : "n/a",
                },
                {
                  Header: "Customer Phone",
                  id: "home_phone",
                  width: 120,
                  filterable: true,
                  sortable: false,
                  accessor: (d) =>
                    d.renter && d.renter.home_phone
                      ? `${d.renter.home_phone}`
                      : "n/a",
                },
              ]}
              defaultPageSize={10}
              filterable
              minRows={5}
              multiSort={false}
              className="-ui -striped -table"
              noDataText={`No ${filterText} Contracts Available`}
              loadingText={`Loading ${filterText} Contracts...`}
              loading={loading}
              rowsText={`${filterText} Contracts`}
              PreviousComponent={prevButton}
              NextComponent={nextButton}
              getTrProps={(state, rowInfo, column) => {
                return {
                  style: {
                    background:
                      rowInfo && rowInfo.original.has_active_rejections
                        ? "#f5d8d8bd"
                        : null,
                  },
                };
              }}
            />
          </div>
          <div style={{ marginTop: "1.5em" }}>
            <ContractCsvDownload
              fetchUrl={this.props.fetchUrl}
              reqData={{
                status: this.state.activeFilter,
                filtered: this.table.current
                  ? this.table.current.state.filtered
                  : [],
              }}
              statusText={filterText}
            />
          </div>
        </Segment>
      </div>
    );
  }
}

EntityContractsTable.defaultProps = {
  dealerId: null,
  showDealer: false,
};

export default EntityContractsTable;
